/* Only loaded by the unpublished draft fallback, never by an available product. */
(() => {
  function connectDraftNavigation() {
    const purchase = document.querySelector('.ruolai-draft-feature')?.closest('.shopify-section');
    const collection = document.querySelector('[id$="__ruolai_more"]');
    if (!purchase) return;
    document.querySelectorAll('a[href]').forEach(link => {
      const href = link.getAttribute('href');
      if (href === '/products/ruolai-odorless-aged-garlic-extract') link.setAttribute('href', '#' + purchase.id);
      if (href === '/collections/all' && collection) link.setAttribute('href', '#' + collection.id);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connectDraftNavigation, { once: true });
  else connectDraftNavigation();
  document.addEventListener('shopify:section:load', connectDraftNavigation);
})();
